<template>
  <Modal 
    v-if="showConfirmationModal" 
    :config="{...modalConfig.confirmAddNewPayee, title: modalTitle,
              btn1Label: cancelButtonLabel}"
    @btn1Action="makeNewPayment(config.resp)"
    @btn2Action="routeToDashboard()">
  </Modal>
</template>

<script>
import store from '@/core/store'
import Modal from '@/components/common/Modal.vue'

export default {
  name: 'ConfirmDeposit',
  components: {
    Modal
  },
  props: {
    config: Object
  },
  data () {
    return {
      showConfirmationModal: true,
      appSettings: this.$appSettings.defaultConfigurations.nominatedAccounts,
      modalConfig: {
        confirmAddNewPayee: {
          enabled: true,
          title: '',
          body: this.getConfirmAddNewPayeeMessage(),
          persistent: true,
          btn1Label: '',
          btn2Label: this.$t('common.goToDashboardBtnLabel'),
          width: 650
        }
      }
    }
  },
  created () {},
  computed: {
    modalTitle() {
      return this.config.isNominatedAccount 
        ? this.$t('confirmAddNewPayee.titleNominatedAccount') 
        : this.$t('confirmAddNewPayee.title')
    },
    cancelButtonLabel() {
      if (this.appSettings.enableNominatedAccountFeatures && this.appSettings.enablePaymentsOnlyToNominatedAccounts) {
        return this.$t("confirmAddNewPayee.viewOwnAccountsLable");
      } else {
        return this.$t("confirmAddNewPayee.viewPayeeList");
      }
    }
  },
  methods: {
    makeNewPayment (account) {
      this.$router.push({
        name: 'Payee',
        params: {
          returnToTab: this.config.resp.details == null ? 0 : 1
        }
      })
      // TODO if (account.details && account.details.paymentSystem && account.details.paymentSystem === 'STEP2') {
      //   this.$router.push({
      //     name: 'InternationalPayments',
      //     params: {
      //       beneficiaryAccount: account.details.accountIdentification
      //     }
      //   })
      // } else {
      //   this.$router.push({
      //     name: 'transferFunds',
      //     params: {
      //       beneficiaryAccount: this.config.selectedAccountType === 0
      //         ? account.beneficiaryAccount
      //         : account.accountNumber
      //     }
      //   })
      // }
    },
    async routeToAccountDetails () {
      store.dispatch('profileStore/setProfileData', {
        selectedPayeeDetails: this.config.resp
      })
      this.$router.push({ name: 'PayeeDetails' })
    },
    routeToDashboard () {
      setTimeout(() => {
        this.$router.push({ path: '/home' })
      }, 600)
    },
    getConfirmAddNewPayeeMessage() {
      return this.config.isNominatedAccount
        ? this.$t("confirmAddNewPayee.subTitleNominatedAcc")
        : this.$t("confirmAddNewPayee.subTitle")
    }
  }
}
</script>
